import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SsoValidateResponse } from 'src/app/_shared/models/sso-validate-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SSOApiService {

  constructor(private http: HttpClient) { }

  public ValidateToken(token: string): Observable<SsoValidateResponse> {
    return this.http.get<SsoValidateResponse>(environment.apiURL + '/sso?ssoToken=' + token);
  };

}
